module.exports = __webpack_public_path__ + "img/person-grey.109d7d2e.svg";